import ArticleServiceForm from '@/components/ArticleServiceForm'
import { SharedProps } from '@/types'
import { Head, Link } from '@inertiajs/react'
import { Button, Group, Paper, Stack, Title } from '@mantine/core'
import { IconArrowLeft } from '@tabler/icons-react'

interface ArticleServiceNewProps extends SharedProps {}

export default function ArticleServiceNew({ current_organization }: ArticleServiceNewProps) {
  const initialData = {
    article_name: '',
    service_name: '',
    price: 0,
    contract_price: '',
    vat_rate: '20',
  }

  return (
    <>
      <Head title={`Nouveau service - ${current_organization?.name}`} />

      <Stack maw={600} mx="auto" w="100%">
        <Group justify="space-between">
          <Button
            component={Link}
            href={`/organizations/${current_organization?.slug}/article_services`}
            variant="subtle"
            color="gray"
            leftSection={<IconArrowLeft size={16} />}
          >
            Retour au catalogue
          </Button>
        </Group>

        <Paper withBorder p="xl" radius="md">
          <Stack gap="xl">
            <Title order={2}>Nouveau service</Title>

            <ArticleServiceForm initialData={initialData} action="new" />
          </Stack>
        </Paper>
      </Stack>
    </>
  )
}
